import { useParams } from '@tanstack/react-router';

export interface PathContext {
  degreeId?: number;
  courseId?: number;
  lessonId?: number;
  objectiveId?: number;
}

const toInt = (value: string | undefined): number | undefined =>
  value ? parseInt(value, 10) : undefined;

export const usePathContext = (): PathContext => {
  const params = useParams({ strict: false }) as {
    degreeId?: string;
    courseId?: string;
    lessonId?: string;
    objectiveId?: string;
  };

  return {
    degreeId: toInt(params.degreeId),
    courseId: toInt(params.courseId),
    lessonId: toInt(params.lessonId),
    objectiveId: toInt(params.objectiveId),
  };
};
